
import React, { useEffect, useRef } from 'react';
// import { formatDot } from './methods';
// import { formatAcuracy, formatNumber } from '@platform/api';

function updateData(pageScope, tableId, data, selectedKeys, fullDataRule, isSelectedTable){
    let { 
        // addRow, 
        // updateTableData, 
        // deleteTableRowsByRowId, 
        setOnlyTableData, 
        selectTableRows,
        getAllTableData,
    } = pageScope.table;
    //---------------代办：把获取新拉平数据的方法拿过来合并一次循环
    // let oldRows = getAllTableData(tableId).rows;
    let newRows = [];
    // let oldRowIds= {};
    // oldRows.forEach(e=>{
    //     oldRowIds[e.rowid] = true;
    // });
    // let newkeysMap={};
    // let addRows=[];
    // let deleteKeys=[];
    // let updateRows=[];
    // 新数据中，旧数据存在的部分，更新，不改变顺序,并保留选中状态
    // 新数据不存在的部分，直接删除；
    // 新数据有，旧数据没有，新增到最后
    let checkedkeys = new Set();
    let iterator = function(row, index, { isChildKey, headKey, childKey } = {} ){
        // if(oldRowIds[row.rowid]){//在旧数据中存在
        //     updateRows.push(row);
            
        // }else{ //在旧数据中不存在
        //     addRows.push(row);
        // }
        newRows.push(row);
        if(!isSelectedTable && selectedKeys){
            if(isChildKey){//取子表选中行
                if(Object.keys(selectedKeys).length && selectedKeys[headKey] && selectedKeys[headKey][childKey]){
                    checkedkeys.add(childKey);
                }
            }else{
                if(selectedKeys[headKey]){
                    checkedkeys.add(headKey);
                }
            }
        }
        
        //newkeysMap[row.rowid] = true;
    };
    if(isSelectedTable){
        getSelectedFullData(data, iterator);
    }else{
        createFullData(data, fullDataRule, iterator);
    }
    //新数据中没有的行删除
    // oldRows.forEach(row=>{
    //     if(!newkeysMap[row.rowid]){
    //         deleteKeys.push(row.rowid);
    //     }
    // });

    //pageScope.beforeUpdatePage();
    // deleteTableRowsByRowId(tableId, deleteKeys);
    // updateTableData(tableId, { rows: updateRows });
    // addRow(tableId, { rows: addRows });
    setOnlyTableData(tableId, { rows: newRows }, false, { disabledClearSort: true, disabledClearFilter: true });
    let allRows = getAllTableData(tableId).rows;
    let checkedIndexs = [];
    allRows.forEach((row, index) => {
        if (checkedkeys.has(row.rowid)) {
            checkedIndexs.push(index);
        }
    });
    //这块还需要处理勾选的拉动，1.联动嵌套表 2.联动全部页签与其他页签
    if(!isSelectedTable && selectedKeys){
        selectTableRows(tableId, checkedIndexs, true);
    }
    //pageScope.updatePage();
}

//合并获取数据的api -----------优化效率
function getSelectedFullData(data, iterator){
    let { masterSelData, childSelData } = data;
    let result = [];
    for (let key of Object.keys(childSelData)) {
        // 存在 没有子表元素的主表数据
        if (childSelData[key] && Object.values(childSelData[key]).length) {
            Object.values(childSelData[key]).forEach(item => {
                // 为了万行
                let childVal = Object.assign({}, item.data.values || item.data || {});
                let headData = Object.assign({}, masterSelData[key].data || {});

                childVal.headKey = headData.key || headData.headKey;
                let newData = Object.assign({}, childVal, headData); //合并后的主子拉平数据
                if (newData.headKey) { newData.headKey = key; }
                newData.key = childVal.key;
                let record = { values: newData, rowid: newData.key };
                iterator && iterator(record);
                result.push(record);
            });
        } else {
            // 没有就取主表数据
            let newData = masterSelData[key].data;
            newData.headKey = key;
            newData.key = key;
            let record = { values: newData, rowid: newData.key };
            iterator && iterator(record);
            result.push(record);
        }
    }
    return result;
}

//合并获取数据的api-----------优化效率
function createFullData(data, fullDataRule, iterator){
    let { outerData, bodyData, fullSortData } = data;
    let result = [];
    let headData = {};
    const CurrentFullDataRule = fullDataRule || 'mainbody';
    if (fullSortData) {
        return fullSortData;
    }

    if (bodyData && bodyData.data) {
        // 为了排序  我豁出去了 以外层数据为标准  可以排序数据
        if (Array.isArray(outerData)) {
            let bodyIndex = 0;
            outerData.forEach((oitem, ii) => {
                let key = oitem.rowId;
                headData[key] = oitem.values;
                let childKey = true;
                //子表有数据时，拉平
                if (bodyData.data[key] && bodyData.data[key].rows && bodyData.data[key].rows.length) {
                    bodyData.data[key].rows.map((item, index) => {
                        let newData = Object.assign({}, item.values, headData[key]); //合并后的主子拉平数据
                        if (Object.prototype.toString.call(CurrentFullDataRule) == '[object Function]') {
                            newData = CurrentFullDataRule(headData[key], item.values) || {};
                        }
                        if (CurrentFullDataRule === 'bodymain') {
                            newData = Object.assign({}, headData[key], item.values );
                        }
                        if (CurrentFullDataRule === 'body') {
                            newData = Object.assign( {}, item.values);
                            newData.headKey = key;
                        }
                        if (CurrentFullDataRule === 'main') {
                            newData = Object.assign({}, headData[key]);
                            childKey = false;
                        }
                        if (!newData.headKey) { newData.headKey = key; }
                        newData.key = childKey ? item.values.key : key;
                        newData.headTs = headData[key]['ts'];
                        let record = { values: newData, rowid: newData.key };
                        iterator && iterator(record, bodyIndex, {
                            isChildKey: childKey,
                            headKey: key,
                            childKey: item.values.key,
                        });
                        bodyIndex ++;
                        result.push(record);
                    });
                    //子表无数据时，只去主表数据作为拉平数据
                } else {
                    childKey = false;
                    let newData = headData[key];
                    newData.headKey = key;
                    newData.key = key;
                    newData.headTs = headData[key]['ts'];
                    let record = { values: newData, rowid: newData.key };
                    iterator && iterator(record, bodyIndex, {
                        isChildKey: childKey,
                        headKey: key,
                    });
                    bodyIndex ++;
                    result.push(record);
                }
            });
        }
    }
    return result;
}

// 此处调用createSimpleTable
export default function Table(props) {
    let { 
        pageScope, 
        moduleId, 
        meta, 
        data, 
        onAllCheckChange,
        onCheckedChange,
        getTableData,
        onCheckboxChangeFull,
        onClearAll,
        pageInfoChange,
        pageInfo,
        onRowClick,
        isSelectedTable = false,
        onRemoveBtnClick,
        json,
        selectedKeys,
        //scroll,
        showCheck=true,
        isDrag,
        showPagination,
        isShow = false,
        editableJSX, //看旧代码只有单来源的数值类型可编辑
        editStatus, //看旧代码只有单来源的数值类型可编辑
        editableItem, //看旧代码但来源数值类型可编辑
        updateEditFlag,
        fullDataRule,
        noTotalRows,
        pkname,
        bodyTableId,
        ...otherConfigs
    } = props;

    //创建ref存储this变量
    const moduleRef = useRef(null);
     let { createSimpleTable, setAllTableData, selectTableRows, getCheckedRows, getAllTableData } = pageScope.table;
    if(!moduleRef.current){
        moduleRef.current = moduleId;
        if(isSelectedTable){
            moduleRef.current = 'selected-' + moduleId;
        }
        pageScope.use.table(moduleRef.current);
        let oldMeta = pageScope.meta.getMeta();

        //统计子表字段名
        let bodyColsMap = {};
        oldMeta[bodyTableId]?.items.forEach( e => {
            bodyColsMap[e.attrcode] = true;
        });
        oldMeta[moduleRef.current] = oldMeta[moduleRef.current] || { ...oldMeta[moduleId], items: [...oldMeta[moduleId].items] };
        oldMeta[moduleRef.current].items.map(item => { 
            if(bodyColsMap[item.attrcode]){
                item.isChildCol = true;  
            }
            return item; 
        });
        //看历史版本 主子拉平后 number类型不支持编辑 没有该功能 暂不实现该功能
        // oldMeta[moduleRef.current].items = meta[moduleId]?.items.map(item=>{
        //     if(item.render){
        //         let oldRender = item.render;
        //         item.render = (text, record, index)=>{
        //             return oldRender(text, record.values||record, index);
        //         };
        //     }else if(editStatus && item.visible && item.itemtype=='number' && !item.disabled){
        //         //数值类型，若数据中有isEdit显示为数值框，否则显示为文本
        //         item.render = (text, record, index)=>{
        //             let isEdit = record[item.attrcode].isEdit;
        //             let recordScale = record[item.attrcode].scale ? record[item.attrcode].scale : item.scale ? item.scale : 0;
        //             let realScale = recordScale;
        //             let dom = record[item.attrcode].display || record[item.attrcode].value;
        //             //精度处理---使用旧代码
        //             if (recordScale === '-1' && dom) {
        //                 let arr = String(dom).split('.');
        //                 if (arr.length && arr[1]) { realScale = arr[1].length; }
        //             }
        //             let val = formatDot(dom, recordScale);
        //             let domShow = formatAcuracy(val, realScale);
        //             domShow = formatNumber(domShow);

        //             if(isEdit){//可编辑时，显示数值框
        //                 return editableJSX(item, dom, index, undefined, record, realScale);
        //             }else{//点击单元格click进行编辑态切换
        //                 return <span
        //                     onClick={e => {
        //                         if (editableItem && !editableItem.includes(item.attrcode)) {
        //                             return;
        //                         }
        //                         e.stopPropagation();
        //                         e.preventDefault();
        //                         if(typeof updateEditFlag === "function"){
        //                             updateEditFlag(item, record, index);
        //                         }
        //                     }}
        //                 >{domShow}</span>;
        //             }
        //         };
        //     }
        //     return item;
        // });
        
        if(isSelectedTable){
            //给模板增加操作列，处理移除按钮
            let label = json['page-transferTable-0006'] ? json['page-transferTable-0006'] : '操作-3';
            let selectItems = oldMeta[moduleRef.current]?.items || [];
            let len = selectItems.length;
            if (selectItems[len - 1] && selectItems[len - 1].attrcode === 'operate_1') {
                selectItems.pop();
            }
            /*国际化处理 操作*/
            let operateColumn = {
                label: label,
                attrcode: 'operate_1',
                itemtype: 'customer',
                dataIndex: 'operate_1',
                width: 100,
                fixed: 'right',
                visible: true,
                render: (text, record, index) => {
                    return (
                        <div
                            className="row-remove"
                            onClick={events => {
                                //需要阻止冒泡
                                events.stopPropagation();
                                onRemoveBtnClick(text, record.values || record, index);
                            }}
                        >
                            {json['page-transferTable-0001'] || '移除'}{/*国际化处理 移除*/}
                        </div>
                    );
                },
            };
            oldMeta[moduleRef.current]?.items?.push(operateColumn);
        }
        pageScope.meta.setMeta(oldMeta);
    }
    
    //初始化设置数据和分页信息
    useEffect(()=>{
        if(isSelectedTable){
            let newData = getSelectedFullData(data);
            setAllTableData(moduleRef.current, { rows: newData });
        }else{
            let checkedIndexs = [];
            let newData = createFullData(data, fullDataRule, ( record, index, { isChildKey, headKey, childKey } ) => {
                if(isChildKey){//取子表选中行
                    if(Object.keys(selectedKeys).length && selectedKeys[headKey] && selectedKeys[headKey][childKey]){
                        checkedIndexs.push(index);
                    }
                }else{
                    if(selectedKeys[headKey]){
                        checkedIndexs.push(index);
                    }
                }
            }); 
            setAllTableData(moduleRef.current, { rows: newData, pageInfo: pageInfo });
            selectTableRows(moduleRef.current, checkedIndexs, true);
        }
    }, []);

    //根据props的data更新表格
    if(isShow){
        //差异更新表格数据，防止排序、筛选等操作后，再勾选 更新时保留表格的数据顺序
        updateData(pageScope, moduleRef.current, data, selectedKeys, fullDataRule, isSelectedTable);
    }

    return (
        createSimpleTable(moduleRef.current, Object.assign({}, {
            showCheck: showCheck,
            isDrag: isDrag, 
            high_selectable: { enable: true },
            showIndex: true,
            adaptionHeight: true,
            addBlankCol: true,
            noTotalRows,
            showPagination: showPagination,
            pkname: pkname,
            relationMetaId: moduleId,
            // onSelected: (props, id, row, rowDataIndex, isChecked)=>{
            //     //此处需要setState不然已选不更新
            //     onCheckboxChangeFull && onCheckboxChangeFull.call(pageScope, undefined, row, rowDataIndex); 
            //     //console.log("onSelected==", id, row, rowDataIndex, isChecked);
            // },
            //shift多选的更新逻辑
            selectedChange: (props,id, checkedKeysSize, lastCheckedKeysSize)=>{
                if(checkedKeysSize != lastCheckedKeysSize){
                    let rows = getCheckedRows(moduleRef.current);
                    let allRows = getAllTableData(moduleRef.current).rows;
                    //找到两次勾选行数据不同的行，只有不相同的行重新执行change方法，相同的不执行
                    //所有勾选的子表key 包含之前查询勾选的、当前表格中没有显示的数据
                    let selectedChildSet = {};
                    Object.values(selectedKeys || {}).forEach(e=>{
                        for(let pop in e){
                            selectedChildSet[pop] = true;
                        }
                    });
                    //是否有当前表格中没有显示的勾选数据(之前查询勾选的) 有则不能走全消逻辑 只取消当前表格中显示的行
                    let hasInvisibleSelected = Object.keys(selectedKeys || {}).some(headKey=>{
                        let childKeys = Object.keys(selectedKeys[headKey] || {});
                        if(childKeys.length){
                            return childKeys.some(k=>!allRows.find(e=>e.values.key === k));
                        }
                        //主表单独勾选(无子表数据)且当前表格没有显示该主表行
                        return !allRows.find(e=>e.values.key === headKey && e.values.headKey === headKey);
                    });
                    if(checkedKeysSize === allRows.length || (checkedKeysSize == 0 && !hasInvisibleSelected)){//全选或者全消
                        //此处需要setState不然已选不更新
                        let isSelAll = checkedKeysSize != 0;
                        onAllCheckChange && onAllCheckChange.call(pageScope, isSelAll);
                        if (isSelAll) {
                            //全选事件
                            let { head: headData, body: bodyData } = getTableData();
                            onCheckedChange && onCheckedChange(isSelAll, JSON.parse(JSON.stringify(headData)), 'all', JSON.parse(JSON.stringify(bodyData)));
                        } else {
                            //全消钩子函数
                            onClearAll && onClearAll();
                        }
                    }else if(checkedKeysSize == 0){
                        //勾选行全部取消 但存在之前查询勾选的、当前表格中没有显示的数据 只取消当前表格中显示的勾选行
                        allRows.forEach((row, index)=>{
                            if(selectedChildSet[row.values.key]){
                                onCheckboxChangeFull && onCheckboxChangeFull.call(pageScope, undefined, row.values, index);
                            }
                        });
                    }else{
                        //取消勾选
                        if(Object.keys(selectedChildSet).length > rows?.length){
                            //找出取消勾选的数据，调用onCheckboxChangeFull
                            for(let k in selectedChildSet){
                                if(!rows.find(e=>{
                                    let key = e.data.key;
                                    return key == k
                                })){
                                    let rowIndex = allRows.findIndex(e=>e.values.key === k);
                                    if(rowIndex != -1){
                                        let row = allRows[rowIndex];
                                        onCheckboxChangeFull && onCheckboxChangeFull.call(pageScope, undefined, row.values, rowIndex); 
                                    }                                 
                                }
                            }

                        }

                        //新勾选，原来没有勾选的数据
                        Array.isArray(rows) && rows.forEach((row)=>{
                            let key = row.data.key;
                            if(!selectedChildSet[key]){
                                onCheckboxChangeFull && onCheckboxChangeFull.call(pageScope, undefined, row.data.values, row.index); 
                            } 
                        })
                    }
                }
            },

            onBatchSelected: (props, areaCode, rows)=>{
                console.log("框选多选事件")
                rows.forEach((item)=>{
                    onCheckboxChangeFull && onCheckboxChangeFull.call(props, undefined, item.values, item.dataIndex); 
                    //console.log("onSelected==", id, item.values, item.dataIndex, isChecked);
                })
               
            },
            // onSelectedAll:(props, id, isSelAll, visibleKeysLength)=>{
            //     console.log("onSelectedAll==", id, isSelAll, visibleKeysLength);
            //     //此处需要setState不然已选不更新
            //     onAllCheckChange && onAllCheckChange.call(pageScope, isSelAll);
            //     if (isSelAll) {
            //         //全选事件
            //         let { head: headData, body: bodyData } = getTableData();
            //         onCheckedChange && onCheckedChange(isSelAll, JSON.parse(JSON.stringify(headData)), 'all', JSON.parse(JSON.stringify(bodyData)));
            //     } else {
            //         //全消钩子函数
            //         onClearAll && onClearAll();
            //     }
            // },
            
        },  {...otherConfigs}))
    );
}

